<template>
    <div class="industryDetail_box" ref="showPdf">
        <Form ref="title" :label-width="100" label-colon="：">
            <Row>
                <Col :sm="{ span: 12}" :xl="{ span: 6}">
                    <FormItem label="三级菜单">
                        <div v-html="industryDetail.thirdMenu.thirdMenuName"></div>
                    </FormItem>
                </Col>
                <Col :sm="{ span: 12}" :xl="{ span: 6}">
                    <FormItem label="日期">
                        <div v-html="industryDetail.createDate"></div>
                    </FormItem>
                </Col>
                <Col :sm="{ span: 12}" :xl="{ span: 6}">
                    <FormItem label="公司">
                        <div v-html="industryDetail.companyName"></div>
                    </FormItem>
                </Col>
                <Col :sm="{ span: 12}" :xl="{ span: 6}">
                    <FormItem label="重要性">
                        <Rate v-model="industryDetail.importantFlag" :count="3" disabled />
                    </FormItem>
                </Col>
                <Col :sm="{ span: 24}" :xl="{ span: 24}">
                    <FormItem label="标题">
                        <div v-html="industryDetail.title"></div>
                    </FormItem>
                </Col>
                <Col :sm="{ span: 24}" :xl="{ span: 24}">
                    <FormItem label="摘要">
                        <div v-html="industryDetail.description"></div>
                    </FormItem>
                </Col>
                <!-- <Col span="24">
                    <FormItem label="文件上传">
                        <Upload multiple type="drag" action="//jsonplaceholder.typicode.com/posts/"
                        :before-upload="beforeUpload" :show-upload-list="false">
                            <div style="padding: 20px 0">
                                <Icon type="ios-cloud-upload" size="52" style="color: #3399ff"></Icon>
                                <p>点击或者拖拽上传文件</p>
                            </div>
                        </Upload>
                    </FormItem>
                </Col> -->
            </Row>
        </Form>
        <div class="main_content" id="mainContent" ref="mainContent">
            <div v-if="isPDF" style="text-align:center;">
                <div v-for="item in totals" :id="`page-${item}`" :key="item" class="pdf-box">
                    <canvas :id="'canvas-pdf-' + item" class="canvas-pdf"></canvas>
                </div>
            </div>
            <div v-if="isDocx" v-html="wordTxt"></div>
        </div>
        <div ref="comment">
            <div ref="commentShow" style="background: #eee">
                <Scroll :on-reach-bottom="handleReachBottom" :height="height">
                    <Row ref="commentInput" type="flex" v-for="(item, index) in commentList" :key="index">
                        <Col span="1">
                            <div class="no-centet">
                                {{index + 1}}
                            </div>
                        </Col>
                        <Col span="19" v-html="item.comment"></Col>
                        <Col span="4" class="rate_btn">
                            <div><Rate :value="item.goodFlag" disabled /></div>
                            <div>{{item.commentDate}}</div>
                            <div>{{item.creator.username}}</div>
                        </Col>
                    </Row>
                </Scroll>
            </div>
            <Row ref="commentInput">
                <Col span="20">
                     <Input v-model="commentValue" placeholder="评论内容" type="textarea" :rows="3"/>
                </Col>
                <Col span="4" class="rate_btn">
                    <div>
                        <Rate v-model="commentRate" />
                    </div>
                    <div style="margin-top:5px">
                        <Button type="primary" style="width:80%" @click="addDocComment">保存</Button>
                    </div>
                </Col>
            </Row>
        </div>
    </div>
</template>

<script>
// import PDFJS from 'pdfjs-dist';
// import { TextLayerBuilder } from 'pdfjs-dist/web/pdf_viewer';
// import 'pdfjs-dist/web/pdf_viewer.css';

import mammoth from 'mammoth';

import api from '@/api/index';
import { timestampToHM } from '@/assets/js/utils';

export default {
    data() {
        return {
            scale: 1.2,
            totals: [],
            pageNo: 1,
            viewHeight: 0,
            scrollbar: '',
            height: 0,
            commentList: [],
            industryDetail: {
                thirdMenu: {}
            },
            isPDF: false,
            isDocx: false,
            commentValue: '',
            commentRate: 0,
            wordTxt: '',
            limit: 5,
            pageNum: 1
        };
    },
    mounted() {
        this.getMainContentWidth();
        this.findIndustryDocByID();
        this.addDocLog();
        this.findByIndustryDocID();
    },
    methods: {
        // 添加浏览记录
        async addDocLog() {
            await api.addDocLog(this.$store.state.industryId);
        },
        // 获取详情的数据
        async findIndustryDocByID() {
            const res = await api.findIndustryDocByID(this.$store.state.industryId);
            this.industryDetail = res.data;
            this.getMainContentWidth();
            this.findIndustryDocFileByID();
        },
        // 获取详情的文件
        async findIndustryDocFileByID() {
            const res = await api.findIndustryDocFileByIDWithBase64(this.$store.state.industryId);
            if (this.industryDetail.fileName === null) {
                return;
            }
            let fileType = this.industryDetail.fileName.split('.');
            if (fileType.length < 2) {
                return;
            }
            fileType = fileType[1].toLowerCase();
            switch (fileType) {
            case 'pdf':
                this.isPDF = true;
                this.renderPdf(res.data);
                break;
            case 'docx':
                this.isDocx = true;
                this.dataURLtoBlob('data:application/vnd.openxmlformats-officedocument.wordprocessingml.document;base64,' + res.data.split(',')[1]);
                break;
            // case 'doc':
            //     this.dataURLtoBlob('data:application/msword;base64,' + res.data.split(',')[1]);
            //     break;
            }
        },
        // base64转ArrayBuffer
        dataURLtoBlob(dataurl) {
            const arr = dataurl.split(',');
            const mime = arr[0].match(/:(.*?);/)[1];
            const bstr = atob(arr[1]);
            let n = bstr.length;
            const u8arr = new Uint8Array(n);
            while (n--) {
                u8arr[n] = bstr.charCodeAt(n);
            }
            const blob = new Blob([u8arr], { type: mime });
            let reader = new FileReader();
            const that = this;
            reader.onload = function(result) {
                mammoth.convertToHtml({ arrayBuffer: result.target.result }).then((result) => {
                    that.wordTxt = result.value;
                });
            };
            reader.readAsArrayBuffer(blob);
        },
        // 已废弃
        beforeUpload(file) {
            this.getBase64(file).then((result) => {
                console.log(result);
            });

            let reader = new FileReader();
            const that = this;
            reader.onload = function(result) {
                console.log(result);
                mammoth.convertToHtml({ arrayBuffer: result.target.result }).then((result) => {
                    that.wordTxt = result.value;
                });
            };
            reader.readAsArrayBuffer(file);
            return false;
        },
        // 获取base64
        getBase64(file) {
            return new Promise((resolve, reject) => {
                let reader = new FileReader();
                let fileResult = '';
                reader.readAsDataURL(file);
                // 开始转
                reader.onload = function() {
                    fileResult = reader.result;
                };
                // 转 失败
                reader.onerror = function(error) {
                    reject(error);
                };
                // 转 结束  咱就 resolve 出去
                reader.onloadend = function() {
                    resolve(fileResult);
                };
            });
        },
        // 获取盒子宽度
        getMainContentWidth() {
            this.contentWidth = parseInt(this.$refs.showPdf.clientWidth - 18);
            this.contentWidth = this.contentWidth > 1000 ? 1000 : this.contentWidth;
            const allNum = this.$refs.showPdf.clientHeight - this.$refs.title.$el.clientHeight;
            const reducNum = parseInt(allNum * 0.3);
            this.$refs.comment.style.height = reducNum + 'px';
            this.$refs.mainContent.style.height = (allNum - reducNum) + 'px';

            const inputNum = this.$refs.commentInput.$el.clientHeight;
            this.height = (reducNum - inputNum);
        },
        // 将PDF内容写入canvas
        // renderPdf(pdfUrl) {
        //     console.log('开始解析');
        //     PDFJS.workerSrc = require('pdfjs-dist/build/pdf.worker.min');
        //     PDFJS.getDocument(pdfUrl).then(pdf => {
        //         const totalPage = pdf.numPages;
        //         const idName = 'canvas-pdf-';
        //         this.createCanvas(totalPage, idName);
        //         for (let i = 1; i <= totalPage; i++) {
        //             pdf.getPage(i).then((page) => {
        //                 const pageDiv = document.getElementById(`page-${i}`);
        //                 // let viewport = page.getViewport(scale)
        //                 const viewportFirst = page.getViewport(1);
        //                 // 计算 scale值，this.contentWidth 为 ref = mainContent 的元素的宽度
        //                 const scale = this.contentWidth / viewportFirst.width;
        //                 const viewport = page.getViewport(scale);
        //                 const canvas = document.getElementById(idName + i);
        //                 const context = canvas.getContext('2d');
        //                 canvas.height = viewport.height;
        //                 canvas.width = viewport.width;
        //                 this.viewHeight = viewport.height;
        //                 const renderContext = {
        //                     canvasContext: context,
        //                     viewport
        //                 };
        //                 page.render(renderContext).then(() => {
        //                     return page.getTextContent();
        //                 }).then((textContent) => {
        //                     // 创建文本图层div
        //                     const textLayerDiv = document.createElement('div');
        //                     textLayerDiv.setAttribute('class', 'textLayer');
        //                     // 将文本图层div添加至每页pdf的div中
        //                     pageDiv.appendChild(textLayerDiv);
        //                     // 创建新的TextLayerBuilder实例
        //                     const textLayer = new TextLayerBuilder({
        //                         textLayerDiv: textLayerDiv,
        //                         pageIndex: page.pageIndex,
        //                         viewport: viewport
        //                     });
        //                     textLayer.setTextContent(textContent);
        //                     textLayer.render();
        //                 });
        //             });
        //         }
        //     });
        // },
        // 生成canvas
        createCanvas(totalPages) {
            for (let i = 1; i <= totalPages; i++) {
                this.totals.push(i);
            }
        },
        // 评论加载
        handleReachBottom(dir) {
            return new Promise(resolve => {
                api.findByIndustryDocID(this.$store.state.industryId, this.limit, this.pageNum).then(res => {
                    for (let val of res.data.data) {
                        val.commentDate = timestampToHM(val.commentDate);
                        this.commentList.push(val);
                        this.pageNum = this.pageNum + 1;
                        resolve();
                    }
                });
            });
        },
        async findByIndustryDocID() {
            const res = await api.findByIndustryDocID(this.$store.state.industryId, this.limit, this.pageNum);
            for (let val of res.data.data) {
                val.commentDate = timestampToHM(val.commentDate);
                this.commentList.push(val);
            }
            this.pageNum = this.pageNum + 1;
        },
        // 新建评论
        async addDocComment() {
            if (this.commentValue === '') {
                this.$Message.warning({
                    background: true,
                    content: '请填写评价内容！'
                });
                return;
            }
            const res = await api.addDocComment(this.$store.state.industryId, this.commentRate, this.commentValue);
            if (res.code !== 200 || res.result !== 'success') {
                this.$Message.warning({
                    background: true,
                    content: '保存失败请重试！'
                });
                return;
            }
            this.commentList.unshift({
                comment: this.commentValue,
                goodFlag: this.commentRate,
                commentDate: timestampToHM(new Date()),
                creator: {
                    username: localStorage.getItem('CMSUserName')
                }
            });
            this.commentValue = '';
            this.commentRate = 0;
        }
    }
};
</script>

<style lang="scss">
    .industryDetail_box {
        overflow: hidden;
        height: 100%;
        .pdf-box {
            position: relative;
            text-align: left;
            display: inline-block;
        }
    }
    .main_content {
        overflow: auto;
    }
    .rate_btn {
        text-align: center;
    }
    .no-centet {
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .comment-box {
        position: relative;
        .comment-detail {
            margin-left: 40px;
            margin-right: 150px;
            height: 100%;
        }
        .comment-no {
            width: 40px;
            // position: absolute;
            // top: 0;
            // left: 0;
            float: left;
            display: flex;
            justify-content: center;
            align-items: center;
            height: 100%;
        }
        .comment-rate {
            width: 150px;
            // position: absolute;
            // top: 0;
            // right: 0;
            float: right;
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            height: 100%;
        }
    }
</style>
<style scoped>
.industryDetail_box >>> .ivu-form-item {
    margin-bottom: 0px;
}
</style>
